<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">
                  Salary Group Detail ({{
                    salaries.length > 0 ? salaries[0].salaryGroup.name : ""
                  }})
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a href="#" class="btn add-btn" @click="openDialog"
                  ><i class="fa fa-plus"></i> Add Salary Item</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="salaries"
                  :item-class="
                    item =>
                      item.salaryElement.categoryId == 2 ? 'red' : 'green'
                  "
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="setEdit(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a class="dropdown-item" @click="setDelete(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.frequency`]="{ item }">
                    {{
                      item.salaryElement.frequency == 1 ? "Monthly" : "Variable"
                    }}
                  </template>
                  <template v-slot:[`item.thirteenMonth`]="{ item }">
                    {{ item.thirteenMonth ? "Yes" : "No" }}
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    {{
                      item.amount
                        .toFixed(2)
                        .toString()
                        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    }}
                  </template>
                  <template v-slot:[`item.variableStartDate`]="{ item }">
                    {{
                      item.variableStartDate
                        ? new Date(item.variableStartDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.variableEndDate`]="{ item }">
                    {{
                      item.variableEndDate
                        ? new Date(item.variableEndDate).toLocaleDateString()
                        : ""
                    }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Salary Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Salary</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Element <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="element">
                    <option>Select Option</option>
                    <option
                      v-for="item in elements"
                      :key="item.id"
                      :value="item"
                    >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Amount <span class="text-danger">*</span></label>
                  <input
                    v-model="amount"
                    id="amount"
                    name="amount"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="form-group">
                  <label
                    >Pay as 13th Month <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="thirteenMonth">
                    <option>Select Action</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div class="form-group" v-if="element.frequency == 2">
                  <label
                    >Variable Start Date <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    name=""
                    id=""
                    v-model="startDate"
                  />
                </div>
                <div class="form-group" v-if="element.frequency == 2">
                  <label
                    >Variable End Date <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    name=""
                    id=""
                    v-model="endDate"
                  />
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Salary Modal -->

        <!-- Edit Salary Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Salary Element</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="updateSalaryElement">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label>Element <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="salary.elementId">
                    <option>Select Option</option>
                    <option
                      v-for="item in elements"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.description }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Amount <span class="text-danger">*</span></label>
                  <input
                    v-model="salary.amount"
                    id="amount"
                    name="amount"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="form-group">
                  <label
                    >Pay as 13th Month <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="salary.thirteenMonth">
                    <option>Select Action</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div
                  class="form-group"
                  v-if="salary.salaryElement.frequency == 2"
                >
                  <label
                    >Variable Start Date <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    name=""
                    id=""
                    v-model="salary.variableStartDate"
                  />
                </div>
                <div
                  class="form-group"
                  v-if="salary.salaryElement.frequency == 2"
                >
                  <label
                    >Variable End Date <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    name=""
                    id=""
                    v-model="salary.variableEndDate"
                  />
                </div>

                <div class="submit-section">
                  <button
                    @click.prevent="updateSalary"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit Salary Modal -->

        <!-- Delete Salary Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Salary</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="removeSalary"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      id: this.$route.params.id,
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      deductions: 0,
      earninng: 0,
      Pearninng: 0,
      reliefs: 0,
      pensionEE: 0,
      pensionER: 0,
      tax: 0,
      password: "",
      salaryPayDay: null,
      today: new Date().getDate(),
      headers: [
        {
          text: "Name",
          align: "start",
          value: "salaryElement.description"
        },
        { text: "Category", value: "salaryElement.salaryCategory.name" },
        { text: "Amount", value: "amount" },
        { text: "13th Month", value: "thirteenMonth" },
        { text: "Frequency", value: "frequency" },
        { text: "Variable StartDate", value: "variableStartDate" },
        { text: "Variable EndDate", value: "variableEndDate" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      amount: "0",
      thirteenMonth: false,
      startDate: "",
      endDate: "",
      elements: [],
      salaries: [],
      salary: {
        salaryElement: {}
      },
      element: {},
      loading: false,
      error: "",
      submitted: false,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      message: null
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    element(val) {
      // set pension
      if (val.subCategoryId == 4) {
        this.amount = (this.Pearninng * 8) / 100;
      }

      //set Tax
      if (val.subCategoryId == 3) {
        this.amount = this.calculateTax(this.earninng, this.pensionEE);
      }

      if (val.subCategoryId == 5) {
        this.amount = (this.Pearninng * 10) / 100;
      }
    }
  },
  methods: {
    clearModel() {
      this.element = {};
      this.amount = "0";
      this.thirteenMonth = false;
      this.startDate = "";
      this.endDate = "";
      this.submitted = false;
    },

    calculateTax(earning, pf) {
      console.log(earning);
      console.log(pf);
      var annualSalary = parseFloat(earning) * 12;
      var annualPension = parseFloat(pf) * 12;
      var CRA = 200000 + (20 * annualSalary) / 100;
      console.log(CRA);
      var taxable = annualSalary - (annualPension + CRA);
      console.log(taxable);
      var first300 = (7 * 300000) / 100;
      taxable = taxable - 300000;
      taxable = taxable < 0 ? 0 : taxable;
      var next300 =
        taxable >= 300000 ? (11 * 300000) / 100 : (11 * taxable) / 100;
      taxable = taxable - 300000;
      taxable = taxable < 0 ? 0 : taxable;
      var next500 =
        taxable >= 500000 ? (15 * 500000) / 100 : (15 * taxable) / 100;
      taxable = taxable - 500000;
      taxable = taxable < 0 ? 0 : taxable;
      var _next500 =
        taxable >= 500000 ? (19 * 500000) / 100 : (19 * taxable) / 100;
      taxable = taxable - 500000;
      taxable = taxable < 0 ? 0 : taxable;
      var next1600 =
        taxable >= 1600000 ? (21 * 1600000) / 100 : (21 * taxable) / 100;
      taxable = taxable - 1600000;
      taxable = taxable < 0 ? 0 : taxable;
      var next3200 =
        taxable == 3200000 ? (24 * 3200000) / 100 : (24 * taxable) / 100;
      var annualtax =
        first300 + next300 + next500 + _next500 + next1600 + next3200;
      return annualtax / 12;
    },

    getElements() {
      const companyId = this.company.id;
      paymentService.getSalaryElements(companyId).then(
        model => {
          this.elements = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getSalaries() {
      const groupId = this.id;
      paymentService.getSalaryGroupAttrs(groupId).then(
        model => {
          this.salaries = model;
          var earn = model
            .filter(c => c.salaryElement.categoryId == 1)
            .map(i => i.amount);
          this.earninng = earn.reduce((a, b) => a + b);
          var Pearn = model
            .filter(
              c =>
                c.salaryElement.frequency == 1 &&
                c.salaryElement.subCategoryId == 8
            )
            .map(i => i.amount);
          this.Pearninng = Pearn.reduce((a, b) => a + b);
          this.deductions = model
            .filter(
              c =>
                c.salaryElement.frequency == 1 &&
                c.salaryElement.categoryId == 2
            )
            .map(i => i.amount)
            .reduce((a, b) => a + b, 0);
          this.reliefs = model
            .filter(c => c.salaryElement.categoryId == 3)
            .map(i => i.amount)
            .reduce((a, b) => a + b, 0);
          this.pensionEE = model.find(
            c =>
              c.salaryElement.frequency == 1 &&
              c.salaryElement.subCategoryId == 4
          )
            ? model.find(
                c =>
                  c.salaryElement.frequency == 1 &&
                  c.salaryElement.subCategoryId == 4
              ).amount
            : 0;
          this.pensionER = model.find(
            c =>
              c.salaryElement.frequency == 1 &&
              c.salaryElement.subCategoryId == 5
          )
            ? model.find(
                c =>
                  c.salaryElement.frequency == 1 &&
                  c.salaryElement.subCategoryId == 5
              ).amount
            : 0;
          this.tax = model.find(
            c =>
              c.salaryElement.frequency == 1 &&
              c.salaryElement.subCategoryId == 3
          )
            ? model.find(
                c =>
                  c.salaryElement.frequency == 1 &&
                  c.salaryElement.subCategoryId == 3
              ).amount
            : 0;
          console.log(this.earninng);
        },
        error => {
          error = error;
        }
      );
    },
    openDialog() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEdit(m) {
      this.salary = m;
      this.dialogEdit = true;
    },
    setDelete(model) {
      this.salary = model;
      this.dialogDelete = true;
    },

    onSubmit() {
      // this.$v.$touch();
      // if (this.$v.$invalid) {
      //      return;
      //  }
      this.submitted = true;

      this.loading = true;
      var req = {
        companyId: this.company.id,
        groupId: this.id,
        elementId: this.element.id,
        amount: parseFloat(this.amount),
        thirteenMonth: this.thirteenMonth,
        startDate: this.startDate,
        endDate: this.endDate
      };

      paymentService.addSalaryGroupAttr(req).then(
        id => {
          this.getSalaries();
          this.close();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    updateSalary() {
      this.submitted = true;

      this.loading = true;
      //console.log(this.resignation);
      paymentService.updateSalaryGroupAttr(this.salary).then(
        id => {
          this.getSalaries();
          this.closeEdit();
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    removeSalary() {
      const id = this.salary.id;
      //console.log(this.resignation);
      paymentService.removeSalaryGroupAttr(id).then(id => {
        this.getSalaries();
        this.closeDelete();
      });
    }
  },

  mounted() {
    this.getSalaries();
    this.getElements();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeeResignations(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "salary"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/salaryGroupAttr.vue